import * as types from '../actions/types';


export default function cartReducer(state = {}, action) {
  switch (action.type) {
    case types.RECEIVE_QUERY_RESULTS:
      return {
        ...state,
        content: action.fallbackData,
      };
    default:
      return state;
  }
}
